import gql from "graphql-tag.macro";

const loadCurrentAccountQuery = gql`
    query currentInstance {
        currentInstance {
            ... on Instance {
                _account
            }
        }
    }
`;

export const loadCurrentAccount = async ({ client }) => {
    const {
        data: {
            currentInstance: {
                _account: accountId,
            },
        },
    } = await client.query({
        query: loadCurrentAccountQuery,
    });
    return accountId;
};
